import { useBranding } from "@/lib/branding";

export const MASCOT_URL = "https://static.prod-images.emergentagent.com/jobs/21befad6-0b31-4984-b443-97e69cf119ed/images/096b024a3b90047df51c3d4f9e91016456428e4b899d5e09b395001ed70102a3.jpeg";

export default function Mascot({ size = 180, className = "", float: shouldFloat = true }) {
  const { mascot_url } = useBranding();
  return (
    <div
      className={`${shouldFloat ? "float" : ""} ${className}`}
      data-testid="tp-mascot"
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        overflow: "hidden",
        border: "4px solid #374151",
        boxShadow: "0 6px 0 0 #374151",
        background: "#FFF8E7",
      }}
    >
      <img src={mascot_url || MASCOT_URL} alt="TP Mascot" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
    </div>
  );
}
